import React, { useState, useCallback, useEffect } from "react";

import {
  Overlay,
  Card,
  ErrorContent,
  SuccessContent,
  ButtonContainer,
} from "./style";
import Questions from "../../../TestContent/Questions";
import Button from "~/components/form/Button";
import { usePost } from "~/services/rest";

import {
  FaExclamationTriangle,
  FaRedo,
  FaPlay,
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";

const InVideoTest = ({
  currentTest,
  onResume,
  idHistoricClass,
  hasNextTest,
  setLessonUpdatedWarning,
}) => {
  const [userAnswers, setUserAnswers] = useState({
    historico_aulas_id: idHistoricClass,
    respostas: [],
  });

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [resAnswerTest, setAnswerTest] = usePost(`historicotesteresposta`);
  const [countdown, setCountdown] = useState(5);

  // handler de seleção de resposta
  const handleUserAnswer = useCallback((idQuestion, idAnswer) => {
    setUserAnswers((prev) => ({
      ...prev,
      respostas: [{ testes_id: idQuestion, respostas_id: idAnswer }],
    }));
  }, []);

  // enviar respostas
  const handleSubmit = async () => {
    if (userAnswers.respostas.length === 0)
      return alert("Selecione uma resposta");
    await setAnswerTest(userAnswers);
  };

  // monitora o resultado do envio
  useEffect(() => {
    if (resAnswerTest.loading) return;

    // Se der erro na API (dados alterados no painel)
    if (
      resAnswerTest.error ||
      (resAnswerTest.data && resAnswerTest.data.erro)
    ) {
      setLessonUpdatedWarning(true);
      setShowSuccess(false);
      setShowError(false);
      return;
    }

    // Se for sucesso (resposta validada)
    if (resAnswerTest.data && resAnswerTest.data.resultado) {
      const { aprovado } = resAnswerTest.data.resultado;
      if (aprovado) {
        setShowSuccess(true);
        setShowError(false);
      } else {
        setShowSuccess(false);
        setShowError(true);
      }
    }
  }, [resAnswerTest, setLessonUpdatedWarning]);

  // controlador da contagem regressiva
  useEffect(() => {
    if (showSuccess) {
      if (countdown > 0) {
        const timer = setTimeout(() => {
          setCountdown((prev) => prev - 1);
        }, 1000);
        return () => clearTimeout(timer);
      } else {
        onResume(true, currentTest);
      }
    }
  }, [showSuccess, countdown, onResume, currentTest]);

  // botão manual para ir para a próxima pergunta
  const handleNextQuestion = () => {
    onResume(true, currentTest);
  };

  // tentar Novamente
  const handleRetry = () => {
    setShowError(false);
    setUserAnswers((prev) => ({ ...prev, respostas: [] }));
  };

  // assistir vídeo novamente
  const handleWatchAgain = () => {
    onResume(false, currentTest);
  };

  const questionsData = [currentTest];

  return (
    <Overlay>
      <Card>
        {showSuccess ? (
          <SuccessContent>
            <FaCheckCircle
              size={60}
              color="#2ecc71"
              style={{ marginBottom: 20 }}
            />
            <h3>Resposta Correta!</h3>

            {/* SE TIVER PRÓXIMA: Mostra o contador E o botão para adiantar */}
            {hasNextTest ? (
              <>
                <p style={{ marginBottom: "15px" }}>
                  Muito bem! A próxima pergunta aparecerá em{" "}
                  <strong>{countdown}</strong> segundos...
                </p>
                <div className="actions">
                  <Button
                    width="220px"
                    theme={{ bdc_hover: "#878787" }}
                    onClick={handleNextQuestion}
                  >
                    Ir Agora <FaArrowRight style={{ marginLeft: 8 }} />
                  </Button>
                </div>
              </>
            ) : (
              /* SE NÃO TIVER: Mostra o texto do vídeo */
              <p>
                Muito bem! O vídeo continuará em <strong>{countdown}</strong>{" "}
                segundos...
              </p>
            )}
          </SuccessContent>
        ) : /* ERRO */
        showError ? (
          <ErrorContent>
            <FaExclamationTriangle
              size={50}
              color="#b70000"
              style={{ marginBottom: 20 }}
            />
            <h3>Resposta Incorreta</h3>
            <p>
              Você gostaria de tentar responder novamente ou rever o conteúdo no
              vídeo?
            </p>

            <div className="actions">
              <Button
                width="200px"
                theme={{
                  bdc_hover: "#878787",
                }}
                onClick={handleRetry}
              >
                <FaRedo style={{ marginRight: 8 }} /> Tentar Novamente
              </Button>

              <Button
                width="200px"
                theme={{
                  bdc_hover: "#878787",
                }}
                onClick={handleWatchAgain}
              >
                <FaPlay style={{ marginRight: 8 }} /> Rever Vídeo
              </Button>
            </div>
          </ErrorContent>
        ) : (
          /* PERGUNTAS */
          <>
            <h3>
              Temos um teste para você! <br />
              <small> Para prosseguir, responda à questão:</small>
            </h3>
            <Questions
              key={showError ? "error" : "normal"}
              questionsData={questionsData}
              handleUserAnswer={handleUserAnswer}
              hideNumbering={true}
            />
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ButtonContainer>
                <Button
                  width="180px"
                  onClick={handleSubmit}
                  disabled={resAnswerTest.loading}
                >
                  {resAnswerTest.loading ? "Verificando..." : "Confirmar"}
                </Button>
              </ButtonContainer>
            </div>
          </>
        )}
      </Card>
    </Overlay>
  );
};

export default InVideoTest;
